module.exports = __webpack_public_path__ + "assets/img/Dover Forest.8556d35e.jpg";